import React from 'react';

const PageTitle = ({ title = '', image = null }) => {
    return (
        <div className='page-title'>
            {image ? (
                <>
                    <h1 className='sr-only'>{title}</h1>
                    <img src={image} alt='' className='img-fluid' />
                </>
            ) : (
                <h1>{title}</h1>
            )}
        </div>
    );
};

export default PageTitle;
